import { Network } from '@capacitor/network';
import {GameDispatcher} from "../pixi/base/GameDispatcher";
import {PluginListenerHandle} from "@capacitor/core";

export class NetworkManager {

  private _networkChangeEvent: GameDispatcher = new GameDispatcher(this);
  private networkListener?: PluginListenerHandle;

  constructor() {}

  async init() {}

  async startListening() {
    if (Network) {
      // Подписка на изменения состояния сети
      this.networkListener = await Network.addListener('networkStatusChange', this.networkChangeHandler.bind(this));
    }
  }

  stopListening(): void {
    if (this.networkListener) {
      // Отписка от изменений состояния сети
      this.networkListener.remove();
      this._networkChangeEvent.removeAllListeners();
    }
  }

  async isReachable(): Promise<boolean> {
    // Проверка состояния сети
    const status = await Network.getStatus();
    return status.connected;
  }

  get networkChangeEvent(): GameDispatcher {
    return this._networkChangeEvent;
  }

  private networkChangeHandler(status: { connected: boolean }): void {
    // Диспатчим событие о изменении состояния сети
    this._networkChangeEvent.dispatch(status.connected);
  }
}
